export const mutations = {
    STORE_SYSTEM_ATTENDANCE (state, attendances) {
        state.attendances = attendances
    },

    STORE_ATTENDANCES (state, attendance) {
        state.attendance = attendance
    },


    STORE_ATTENDANCE_UPDATE(state, attendanceId){
        let Attendance = state.attendance.find(function(attendance){
            return attendance.id === attendanceId
        })
        state.systemAttend = Attendance
    }
    
}
export default mutations


// WEBPACK FOOTER //
// ./src/vuex/modules/attendances/mutations.js